import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=d5ff9afc&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5ff9afc')) {
      api.createRecord('d5ff9afc', component.options)
    } else {
      api.reload('d5ff9afc', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=d5ff9afc&", function () {
      api.rerender('d5ff9afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IAVyz2XvJ3DO/JS/comp/childrenage.vue"
export default component.exports